import axios from "axios";

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getSpecialist({state}, payload) {
            if (!state) {
                return;
            }
            const response = await axios.get('/api/page/' + payload.id);
            return response.data;
        },
        async getSpecialists({state},) {
            if (!state) {
                return;
            }
            const response = await axios.get('/api/pages/specialists?limit=100');
            return response.data;
        },
        async getSpecialistsByCategory({state}, payload) {
            if (!state) {
                return;
            }
            const response = await axios.get('/api/pages/specialists?limit=100&filter[category]=' + payload.categoryId);
            return response.data;
        },
        async getHomeSpecialists({state},) {
            if (!state) {
                return;
            }
            const response = await axios.get('/mock-api/home-specialists.json');
            return response.data;
        },
        async getSpecialistsByIds({state}, ids) {
            if (!state || !Array.isArray(ids) || ids.length === 0) {
                return;
            }
            try {
                const requests = ids.map(id => axios.get(`/api/page/${id}`));
                const responses = await Promise.all(requests);
                return responses.map(response => response.data);
            } catch (error) {
                console.error("Error fetching specialists by IDs:", error);
                throw error; // Re-throw the error to handle it further up the call stack
            }
        }

    }
};
